import React, { Component } from 'react'
import styled from 'styled-components'
import { H4 } from 'app/common/typography'
import { updateProductSelected } from 'shared/utils/ecommerce/utils'
import { CatalogProductGroup } from '../catalog-product-group/CatalogProductGroup'
import type { PurchasableItem } from 'shared/store/ecommerce/order'
import type { Step } from 'shared/store/ecommerce/catalog'
import { media } from 'app/assets/styles'
import type { EventMetadata } from 'shared/store/metadata'
import { productsWithSelectedAllergens } from 'shared/store/ecommerce/catalog'
import { menuSize } from 'shared/utils'

const { S: MENU_SIZE_S, L: MENU_SIZE_L, XL: MENU_SIZE_XL } = menuSize

type Props = {
    step: Step,
    index: number,
    length: number,
    currentOrder?: PurchasableItem,
    isFromCart: boolean,
    featureCustoAvailable: boolean,
    featureExtraAvailable: boolean,
    featurePaidSideDishes: boolean,
    isPromotion: boolean,
    hasSuggestions: boolean,
    updateOrder: (position: number, newOrder: ?PurchasableItem) => void,
    sendMeta: EventMetadata => void,
    collectMode: string,
    selectedAllergens: string[],
    noExtraPriceForProducts?: boolean
}

type State = {
    listProducts: any
}

class CatalogMenuStep extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        const { index } = this.props
        this.state = {
            listProducts: this.updateListProducts(index)
        }
    }

    componentDidUpdate(prevProps: Props) {
        const { currentOrder, index } = this.props

        if (
            prevProps.currentOrder &&
            currentOrder &&
            prevProps.currentOrder.menuSize !== currentOrder.menuSize
        ) {
            this.setState({ listProducts: this.updateListProducts(index) })
        }
    }

    updateListProducts = (index: number) => {
        const { currentOrder, step, isFromCart, selectedAllergens } = this.props
        let products = step.products || []
        if (currentOrder && currentOrder.menuSize === MENU_SIZE_XL) {
            products = step.productsXL || []
        }

        if (currentOrder && currentOrder.menuSize === MENU_SIZE_L) {
            products = step.productsL || []
        }
        if (currentOrder && currentOrder.menuSize === MENU_SIZE_S) {
            products = step.productsS || []
        }
        if (currentOrder) {
            products = productsWithSelectedAllergens(
                products,
                selectedAllergens
            )
        }

        return isFromCart &&
            currentOrder &&
            currentOrder.steps &&
            currentOrder.steps.length > index
            ? updateProductSelected(
                  products,
                  currentOrder.steps[index].id,
                  true
              )
            : products
    }

    render() {
        const {
            currentOrder,
            index,
            length,
            updateOrder,
            step,
            isPromotion,
            featureCustoAvailable,
            featureExtraAvailable,
            hasSuggestions,
            sendMeta,
            collectMode,
            featurePaidSideDishes,
            noExtraPriceForProducts,
            isFromCart
        } = this.props
        const { listProducts } = this.state

        return (
            <Container>
                <StyledH4>{step.name}</StyledH4>

                <CatalogProductGroup
                    listProducts={listProducts}
                    dispatchOrder={order => {
                        updateOrder(index, order)
                        this.forceUpdate()
                    }}
                    notLastCategory={
                        hasSuggestions ? true : index !== length - 1
                    }
                    order={
                        currentOrder && currentOrder.steps
                            ? currentOrder.steps[index]
                            : undefined
                    }
                    collectMode={collectMode}
                    isPromotion={isPromotion}
                    featureCustoAvailable={
                        (isFromCart || featureCustoAvailable) &&
                        currentOrder?.steps[index]?.canBeCustomized
                    }
                    featureExtraAvailable={
                        !isPromotion &&
                        (isFromCart || featureExtraAvailable) &&
                        currentOrder?.steps[index]?.canBeCustomized
                    }
                    featurePaidSideDishes={featurePaidSideDishes}
                    sendMeta={sendMeta}
                    noExtraPrice={noExtraPriceForProducts}
                />
            </Container>
        )
    }
}

const Container = styled.div`
    margin: 20px 0;
    ${media.medium`
        margin: 70px 0;
    `};
`

const StyledH4 = styled(H4)`
    margin-bottom: 20px;
`

export { CatalogMenuStep }
